import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import tripService from './tripService'

const initialState = {
    trips: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: '',
    actionType: 'get',
}

export const createTrip = createAsyncThunk('trips/create', async (tripData, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await tripService.createTrip(tripData, token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const editTrip = createAsyncThunk('trips/edit', async (tripData, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await tripService.editTrip(tripData, token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const getTrips = createAsyncThunk('trips/getAll', async (_, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await tripService.getTrips(token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const deleteTrip = createAsyncThunk('trips/delete', async (id, { getState, rejectWithValue }) => {
    try {
        const token = getState().auth.user.token
        return await tripService.deleteTrip(id, token)
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || error.message || error.toString())
    }
})

export const tripSlice = createSlice({
    name: 'trip',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(createTrip.pending, (state) => {
                state.isLoading = true
                state.actionType = 'create'
            })
            .addCase(createTrip.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.trips.push(action.payload)
            })
            .addCase(createTrip.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(editTrip.pending, (state) => {
                state.isLoading = true
                state.actionType = 'edit'
            })
            .addCase(editTrip.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.trips = state.trips.map(trip =>
                    trip.value === action.payload.updatedTrip.value ? action.payload.updatedTrip : trip
                )
            })
            .addCase(editTrip.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(getTrips.pending, (state) => {
                state.isLoading = true
                state.actionType = 'get'
            })
            .addCase(getTrips.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.trips = action.payload
            })
            .addCase(getTrips.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })

            .addCase(deleteTrip.pending, (state) => {
                state.isLoading = true
                state.actionType = 'delete'
            })
            .addCase(deleteTrip.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.trips = state.trips.filter(
                    (trip) => trip.value !== action.payload.id
                )
            })
            .addCase(deleteTrip.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }
})

export const { reset } = tripSlice.actions
export default tripSlice.reducer